import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const animateAboutCompany = () => {
  const section = document.querySelector(
    '.section[data-block="about-company"]'
  );

  if (!section) return;

  const title = document.querySelector('[data-element="about-company-title"]');

  const textBlock = document.querySelector(
    '[data-element="about-company-text"]'
  );
  const imageBlock = document.querySelector(
    '[data-element="about-company-image"]'
  );

  if (!title || !textBlock || !imageBlock) return;

  ScrollTrigger.matchMedia({
    '(min-width: 1240px)': function () {
      gsap.fromTo(
        section,
        {'--line-height': '0%'},
        {
          '--line-height': '100%',
          duration: 1.2,
          ease: 'none',
          delay: 0.2,
          scrollTrigger: {
            trigger: section,
            start: 'top 80%',
            ease: 'none',
          },
        }
      );

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: 'top 80%',
        },
      });

      tl.fromTo(
        title,
        {
          x: '45%',
        },
        {
          x: 0,
          duration: 1,
          ease: 'none',
        }
      )
        .fromTo(
          textBlock,
          {
            x: '100%',
          },
          {
            x: 0,
            duration: 1,
            ease: 'none',
          },
          '<'
        )
        .fromTo(
          imageBlock,
          {
            x: '-100%',
          },
          {
            x: 0,
            duration: 1,
            ease: 'none',
          },
          '<'
        );
    },
  });
};

export {animateAboutCompany};
